/**
 * The type of Redux action which Sets information about device selection popup.
 *
 * {{
 *     type: SET_DEVICE_SELECTION_POPUP_DATA,
 *     popupDialogData: Object
 * }}.
 */
export const SET_DEVICE_SELECTION_POPUP_DATA
    = 'SET_DEVICE_SELECTION_POPUP_DATA';
